import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import React from "react";

export const WorkspaceDatePicker = ({settings}) => {
    return (
        <DatePicker
            value={settings.value ? dayjs(settings.value) : null}
            format="MMM. D, YYYY"
            minDate={settings.minDate !== null ? dayjs().add(settings.minDate, 'day') : null}
            onChange={(newValue) => settings.onChange(newValue)}
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [10, 10],
                            },
                        },
                    ],
                },
                textField: {
                    fullWidth: true,
                    fullHeight: true,
                    sx: {
                        '& .MuiOutlinedInput-input': {
                            color: 'var(--main-normal-color)',
                            fontFamily: '"Open Sans", Arial, sans-serif',
                            fontSize: '12px',
                            padding: 0,
                            paddingTop: '2px',
                            paddingBottom: '2px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                    },
                    InputLabelProps: {
                        shrink: true,
                    }
                },
            }}
        />
    )
}